import { useRouter } from 'next/router';
import {
    FC, ReactElement, ReactNode, useEffect, useState,
} from 'react';

type Props = {
    children : ReactNode;
    hasCustomMain ?: boolean;
};

const GeneralHandler : FC<Props> = ({ children, hasCustomMain = false }) : ReactElement => {
    const router = useRouter();
    const [footerHeight, setFooterHeight] = useState<number>(0);
    const [headerHeight, setHeaderHeight] = useState<number>(0);

    useEffect(() => {
        const footer = document.getElementById('contact');

        if (footer) {
            setFooterHeight(footer.clientHeight);
        }

        const header = document.getElementsByTagName('header')[0];

        if (header) {
            setHeaderHeight(header.clientHeight);
        }
    }, []);

    useEffect(() => {
        if (!router.pathname?.includes('/app/')) {
            document.body.classList.add('front');
        } else {
            document.body.classList.remove('front');
        }
    }, [router]);

    return (
        <>
            {
                hasCustomMain
                    ? (
                        <main>{children}</main>
                    )
                    : <div style={{ minHeight: `calc(100vh - ${footerHeight}px - ${headerHeight}px )` }}>
                        {children}
                    </div>
            }
        </>
    );
};

export default GeneralHandler;
